//export const API_URL = 'https://cagzcajq30.execute-api.us-east-1.amazonaws.com/dev/todos'
//export const API_URL = 'https://nnvr7ppuc1.execute-api.us-east-1.amazonaws.com/dev/todos'
//export const API_URL = 'http://localhost:7071/api/todos'
export const API_URL = 'https://rest-api-management.azure-api.net/todos-function-app/todos'
// chinmay@nityachinmaygmail.onmicrosoft.com / Bhubaneswar36@

export const POOL_DATA = {
    UserPoolId: 'us-east-1_pqVtBaQZO',
    ClientId: '1d9biedjhtn8onjgnm2qn17aiv'
};